import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot à la place de ReactDOM
import App from './App'; 

// Sélectionne l'élément racine du DOM
const rootElement = document.getElementById('root');

// Crée le root et utilise la méthode render de createRoot
const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
